import { render, staticRenderFns } from "./FilterSummaryTermPos.vue?vue&type=template&id=272f4ae2&"
import script from "./FilterSummaryTermPos.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryTermPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports